module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "mymap",
    attrs: {
      "center": _vm.geoLocation,
      "zoom": 20
    }
  }, [(_vm.pInfo.valid) ? _c('gmap-info-window', {
    attrs: {
      "options": _vm.pInfo.options,
      "position": _vm.pInfo.coordinates,
      "opened": _vm.pInfo.opened,
      "content": _vm.pInfo.content
    },
    on: {
      "closeclick": function($event) {
        _vm.pInfo.opened = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.$store.getters.filteredModel('areas')), function(area, i) {
    return _c('gmap-marker', {
      attrs: {
        "position": _vm._f("calcGeoLocation")(area.coordinates),
        "icon": _vm._f("calcIcon")(area),
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(area, i)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c51a0b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map-marker.vue
// module id = 437
// module chunks = 0